import { tagColors } from "@/components/tag/tag-colors";
export const CostSupplementEnum = {
  costType: {
    INBOUND_COST: 'inboundCost',
    STORAGE_COST: 'storageCost'
  },
  costTypeOption: [
    {id: 'inboundCost', text: '入库成本'},
    {id: 'storageCost', text: '库存成本'},
  ],
  status: {
    WAIT_REVIEW: 'waitReview',
    PROCESSED: 'processed',
    REJECTED: 'rejected',
  },
  statusOption: [
    {id: 'waitReview', text: '待审核', ...tagColors.orange},
    {id: 'processed', text: '已处理', ...tagColors.green},
    {id: 'rejected', text: '已驳回', ...tagColors.red},
  ]
};
